export const messages = {
  'zh-CN': {
    brand: 'HiveCloud',
    controlPlane: '云端控制面',
    workspace: '工作区',
    notifications: '通知',
    eyebrow: '稳定、安全的云端控制面',
    heroTitle: '让每个运行环境',
    heroTitleAccent: '都触手可及。',
    heroDescription: '在一个可信的工作台中，掌握云端运行环境的在线状态、就绪程度与归属。',
    serverSessions: '服务端会话',
    deviceIdentity: '设备绑定身份',
    signInTitle: '欢迎回来',
    signInDescription: '登录 HiveCloud，管理你的设备与运行环境',
    codeSignIn: '验证码登录',
    passwordSignIn: '密码登录',
    codeSentTo: '验证码已发送至',
    changePhone: '修改手机号',
    otherLoginMethods: '其他登录方式',
    accountOrEmail: '手机号或邮箱',
    password: '密码',
    passwordPlaceholder: '请输入密码',
    forgotPassword: '忘记密码？',
    countryOrRegion: '选择国家或地区',
    showPassword: '显示密码',
    hidePassword: '隐藏密码',
    sendSmsLoading: '正在发送验证码…',
    continueAction: '继续',
    smsCodeExpired: '验证码已过期，请重新获取',
    smsCodeExpires: '验证码将在 {seconds}s 后失效',
    secureTransfer: '安全加密传输',
    helpCenter: '帮助中心',
    privacyPolicy: '隐私政策',
    selectLanguage: '选择语言',
    loginMethodLabel: '登录方式', countryRegionLabel: '选择国家或地区', smsCodeLabel: '短信验证码', agreementPrefix: '我已阅读并同意', agreementAnd: '和', continueToSignInLabel: '继续登录', phoneInvalid: '请输入正确的手机号', termsRequired: '请先阅读并同意服务条款和隐私政策',
    signIn: '登录 HiveCloud',
    registerPrompt: '还没有账号？',
    register: '创建账号',
    identityHint: '登录凭据由 HiveCloud 身份服务保护，不会保存在浏览器中。',
    authenticationProgress: '身份验证进度',
    accountVerification: '账号验证',
    deviceAuthorization: '设备授权',
    complete: '完成',
    identityServiceNotice: '凭据由统一身份服务处理',
    identityServiceNoticeDesc: '继续后将在 HiveCloud Identity 中安全输入账号、密码或多因素验证码。',
    continueToIdentity: '继续登录',
    smsLoginTitle: '手机号登录 HiveCloud',
    smsLoginDescription: '输入手机号获取验证码，验证后即可登录或自动创建账号。',
    phoneNumber: '手机号',
    phoneNumberPlaceholder: '请输入手机号',
    smsCode: '短信验证码',
    smsCodePlaceholder: '输入 6 位验证码',
    smsTerms: '我已阅读并同意服务条款与隐私政策',
    sendSmsCode: '获取验证码',
    verifySmsCode: '验证并登录',
    passwordLogin: '使用账号密码登录',
    smsInputInvalid: '请输入有效手机号并同意服务条款。',
    smsSendFailed: '验证码发送失败，请稍后重试。',
    smsRateLimited: '短信发送过于频繁，请稍后再试。',
    smsCodeInvalid: '请输入 6 位短信验证码。',
    smsVerifyFailed: '验证码无效或已过期，请重新获取。',
    smsLoginCompleteFailed: '验证码已通过，但身份服务未能完成登录，请稍后重试。',
    smsExpiryHint: '验证码将在 {seconds} 秒后失效。',
    smsResendHint: '{seconds} 秒后可重新获取',
    smsResend: '重新获取验证码',
    smsCancel: '取消验证',
    secureConnection: '安全连接',
    artNoteTitle: '专注构建，不中断工作流。',
    artNoteDescription: '账号身份与设备权限彼此独立、清楚可见，并始终由你控制。',
    approveSignInTitle: '批准 HiveCloud 登录',
    approveSignInDescription: '账号身份已验证。请确认本次设备授权和登录有效期。',
    shortCredentialTitle: '短期访问凭据将自动轮换',
    shortCredentialDescription: '10 分钟仅是访问令牌期限；下方选择决定真正的登录授权期限。',
    application: '应用',
    requestingDevice: '请求设备',
    currentBrowserProfile: '当前浏览器配置',
    authorizationPolicy: '授权策略',
    trustedPolicy: '可信 · 最长 90 天',
    temporaryPolicy: '临时 · 最长 24 小时',
    trustThisDevice: '信任此设备',
    trustedDeviceHint: '仅适用于私人设备。',
    temporaryDeviceHint: '共享设备应保持临时登录。',
    cancelRequest: '取消请求',
    approveSignIn: '批准登录',
    pendingApproval: '待批准',
    currentAccount: '当前登录账号',
    currentEnvironment: '当前环境',
    justNow: '刚刚',
    temporaryDevice: '临时设备',
    trustedDevice: '受信任设备',
    temporaryPolicyDescription: '最长 24 小时，适合共享电脑或临时环境。',
    trustedPolicyDescription: '最长 90 天，仅适合你本人拥有并控制的设备。',
    recommendedWhenUnsure: '无法确认是否私人设备时推荐',
    beforeApproval: '批准前请确认',
    approvalCheckApp: '请求来自 HiveCloud Web。',
    approvalCheckDevice: '当前浏览器与设备环境符合预期。',
    approvalCheckTrusted: '仅在私人设备上选择受信任授权。',
    approvalPrivacyNotice: '页面不会显示 nonce、公钥、签名、Authorization Code 或其他技术凭证。',
    callback: '正在完成安全登录',
    callbackDesc: '正在验证会话和设备身份，请稍候。',
    browserUnsupported: '当前浏览器不支持安全设备身份',
    browserUnsupportedDesc: '请使用 Chrome/Edge 137+、Firefox 129+ 或 Safari 17+。',
    browserRequirement: '需要启用 WebCrypto Ed25519 与 IndexedDB。',
    overview: '概览',
    runtimes: '运行环境',
    personalWork: '个人工作',
    personalWorkDescription: '按 Runtime 管理个人工作项，并安全打开 Web 工作区。',
    personalWorkSubtitle: '只保存标题、状态和 Runtime 绑定，不保存代码、凭据或工作区内容。',
    createPersonalWork: '新建工作项',
    workTitle: '标题',
    workTitlePlaceholder: '例如：整理本周发布说明',
    workRuntime: '绑定 Runtime',
    workStatus: '状态',
    workUpdatedAt: '更新时间',
    workVersion: '资源版本',
    workSessions: '关联 Web 会话',
    noPersonalWork: '还没有个人工作项',
    personalWorkCreated: '工作项已创建',
    personalWorkSaved: '工作项已保存',
    personalWorkCreateHint: '选择一个已绑定且可用的 Runtime。',
    personalWorkOpenHint: '打开操作会创建一次受控的 Cloud-managed Web 会话。',
    personalWorkRuntimeUnavailable: '该 Runtime 当前不满足安全 Web 启动条件。',
    personalWorkSessionNone: '暂无关联 Web 会话。',
    personalWorkStatus_TODO: '待处理',
    personalWorkStatus_IN_PROGRESS: '进行中',
    personalWorkStatus_IN_REVIEW: '待审阅',
    personalWorkStatus_COMPLETED: '已完成',
    personalWorkStatus_ARCHIVED: '已归档',
    devices: '设备',
    sessions: '活跃会话',
    loginDevices: '登录设备',
    loginDevicesTitle: '登录设备管理',
    loginDevicesDescription: '管理可以登录和访问当前账号的设备，设置设备别名或移除异常设备。',
    devicesCount: '台设备',
    loginLocation: '登录地点',
    lastLoginOrUse: '最后登录 / 使用',
    deviceNamePlaceholder: '输入设备别名',
    deviceNameRequired: '请输入 1–128 个字符的设备别名。',
    account: '账户',
    backToConsole: '返回控制台',
    securityCenter: '账户安全中心',
    accountProfile: '账户资料',
    accountProfileDescription: '查看由统一身份服务维护的账户信息。',
    devicesEyebrow: '设备访问',
    sessionsEyebrow: '会话管理',
    mfaEyebrow: '登录保护',
    recoveryEyebrow: '身份恢复',
    lifecycleEyebrow: '账户生命周期',
    legal: '隐私与条款',
    support: '帮助与支持',
    signOut: '退出登录',
    language: '语言',
    welcome: '早上好，{name}',
    overviewSubtitle: '这里是你的 HiveCloud 工作台。',
    activeRuntimes: '活跃运行环境',
    accountStatus: '账号状态',
    healthy: '运行正常',
    attention: '需要关注',
    viewAll: '查看全部',
    recentRuntimes: '最近的运行环境',
    noData: '暂无数据',
    loadMore: '加载更多',
    retry: '重试',
    refresh: '刷新',
    runtimeDetail: '运行环境详情',
    runtimeId: '运行环境 ID',
    displayName: '云端名称',
    version: '版本',
    status: '状态',
    presence: '在线状态',
    readiness: '就绪程度',
    lastSeen: '最近活动',
    region: '区域',
    runtimeDeviceInfo: '设备信息',
    runtimeDeviceInfoDescription: '由 Runtime 最近一次心跳上报；未上报的字段显示为“—”。',
    runtimeDeviceName: '设备名称',
    operatingSystem: '操作系统',
    processor: '处理器',
    memory: '内存',
    lastSeenIp: '最近来源 IP',
    availableDisk: '可用磁盘',
    protocolVersion: '协议版本',
    runtimeCapabilities: 'Runtime 能力',
    connectionCapabilities: '连接能力',
    runtimeStartedAt: '启动时间',
    runtimeAlias: '云端别名',
    editRuntimeAlias: '修改云端别名',
    runtimeAliasDescription: '别名跟随账号显示，不会修改设备的物理名称。',
    runtimeAliasPlaceholder: '例如：办公室工作站',
    runtimeAliasHelp: '最多 {max} 个字符；留空保存将清除别名。',
    clearRuntimeAlias: '清除别名',
    runtimeAliasSaved: '云端别名已更新',
    runtimeAliasTooLong: '别名不能超过 {max} 个 Unicode 字符。',
    runtimeAliasForbiddenCharacters: '别名不能包含控制字符或双向文本控制符。',
    runtimeAliasConflict: '别名已在其他位置更新。已刷新最新版本，你的输入已保留，请重试保存。',
    runtimeAliasAlreadyCurrent: '已刷新最新状态，云端别名已与当前输入相同。',
    runtimeAliasConflictRefreshFailed: '别名已发生冲突，但最新状态刷新失败。你的输入已保留，请稍后重试。',
    runtimeAliasSaveFailed: '云端别名保存失败，当前页面未误报更新。',
    runtimeAliasUnsupported: '当前服务未提供别名版本，暂不支持编辑。',
    claim: '认领运行环境',
    claimCapability: '认领能力',
    expectedVersion: '当前资源版本',
    claimDescription: '认领后，这个运行环境将绑定到你的云端账号。',
    claimPreview: '认领预览',
    confirmClaim: '确认认领',
    cancel: '取消',
    claimSuccess: '运行环境已成功认领',
    claimInvalid: '认领请求已失效，请重新发起。',
    stepUpRequired: '请完成多因素认证后继续。',
    edit: '编辑',
    save: '保存',
    saved: '已保存',
    revoke: '撤销',
    revokeDevice: '撤销设备',
    revokeSession: '退出会话',
    revokeAll: '撤销全部',
    current: '当前设备',
    trusted: '可信',
    untrusted: '未验证',
    revoked: '已撤销',
    retired: '已停用',
    deviceDescription: '管理可以访问云端账号的设备身份。',
    sessionDescription: '查看最近的登录活动，发现异常时可立即退出。',
    openInWeb: '在 Web 中打开',
    openingInWeb: '正在安全打开…',
    webLaunch_popup_blocked: '浏览器阻止了新窗口。请允许此站点打开弹窗，然后重试。',
    webLaunch_expired: '本次 Web 启动已过期。请刷新运行环境状态后重试。',
    webLaunch_offline: '运行环境当前离线。请在其重新上线后刷新并重试。',
    webLaunch_fenced: '运行环境状态已变化。请刷新后重新发起安全连接。',
    webLaunch_unavailable: '暂时无法打开 Web 工作区。请刷新状态后重试。',
    managedWebSessions: 'Web 连接记录',
    managedWebSessionsDescription: '查看由云端授权的 Web 工作区连接；撤销只有在 Runtime 确认后才算完成。',
    noManagedWebSessions: '暂无 Cloud-managed Web 会话',
    runtimeSession: '运行环境会话',
    createdAt: '创建时间',
    expiresAt: '过期时间',
    revokeWebSessionConfirm: '请求撤销此 Web 会话？在 Runtime 确认前，状态会保持为待撤销或待确认。',
    webRevocationRequested: '已提交撤销请求，正在等待 Runtime 确认。',
    webSession_ACTIVE: '活跃',
    webSession_REVOKE_PENDING: '撤销待确认',
    webSession_REVOKED: '已撤销',
    webSession_EXPIRED: '已过期',
    webSession_UNVERIFIABLE: '状态待确认',
    accountDescription: '管理个人资料、登录安全和账号生命周期。',
    security: '安全',
    mfa: '多因素认证',
    enabled: '已启用',
    disabled: '未启用',
    recovery: '恢复与验证',
    recoveryDescription: '验证身份并替换丢失的设备密钥。',
    configureMfa: '配置 MFA',
    deleteAccount: '计划删除账户',
    cancelDeletion: '取消删除申请',
    memberSince: '加入时间',
    securityVersion: '安全版本',
    profile: '个人资料',
    dangerZone: '危险操作',
    deletionPendingDescription: '删除申请已提交，请在宽限期结束前恢复账号访问。',
    deletionScheduledDescription: '删除操作会退出所有设备，并安排永久移除账号。',
    identifier: '标识信息',
    claimedAt: '认领时间',
    policyTitle: '隐私与服务条款',
    policyUpdated: '最后更新：2026 年 8 月 20 日',
    policyBody: 'HiveCloud 仅为提供运行环境控制面而处理必要的账号、设备和审计信息。我们不会将凭据存储在浏览器中，所有会话均由服务端保护。',
    privacyByDesign: '隐私设计',
    serviceTerms: '服务条款',
    serviceTermsBody: '使用 HiveCloud 即表示你接受所在组织的服务协议。我们会审计安全相关操作，以保护你和所在组织。',
    contact: '联系信息',
    supportTitle: '需要帮助？',
    supportBody: '如果你遇到登录、设备恢复或运行环境认领问题，请联系组织管理员。',
    contactSupport: '联系支持',
    runtimeClaim: '运行环境认领',
    runtimeClaimDescription: '报告认领问题时，请同时提供运行环境 ID。',
    deviceRecoveryDescription: '更换设备密钥前需要完成身份验证。',
    loading: '加载中…',
    forbidden: '没有访问权限',
    unauthorized: '会话已过期',
    notFound: '页面不存在',
    error: '暂时无法加载',
    active: '活跃',
    online: '在线',
    offline: '离线',
    pending: '准备中',
    present: '已连接',
    away: '暂离',
    unknown: '未知',
    ready: '就绪',
    starting: '启动中',
    degraded: '性能下降',
    recovering: '恢复中',
    needs_setup: '需要配置',
    blocked: '已阻止',
    confirm: '确认',
    close: '关闭',
  },
  'en-US': {
    brand: 'HiveCloud',
    controlPlane: 'Cloud control plane',
    workspace: 'WORKSPACE',
    notifications: 'Notifications',
    eyebrow: 'A calm, secure cloud control plane',
    heroTitle: 'Keep every Runtime',
    heroTitleAccent: 'within reach.',
    heroDescription: 'One trusted place to understand presence, readiness, and ownership across your cloud.',
    serverSessions: 'Server-side sessions',
    deviceIdentity: 'Device-bound identity',
    signInTitle: 'Welcome back',
    signInDescription: 'Sign in to HiveCloud to manage your devices and Runtimes.',
    codeSignIn: 'Code sign-in', passwordSignIn: 'Password sign-in', codeSentTo: 'Code sent to', changePhone: 'Change number', otherLoginMethods: 'Other sign-in methods', accountOrEmail: 'Phone or email', password: 'Password', passwordPlaceholder: 'Enter your password', forgotPassword: 'Forgot password?', countryOrRegion: 'Choose country or region', showPassword: 'Show password', hidePassword: 'Hide password', sendSmsLoading: 'Sending code…', continueAction: 'Continue', smsCodeExpired: 'The code has expired. Request a new one.', smsCodeExpires: 'The code expires in {seconds}s', secureTransfer: 'Secure encrypted transfer', helpCenter: 'Help center', privacyPolicy: 'Privacy policy', selectLanguage: 'Choose language', loginMethodLabel: 'Sign-in method', countryRegionLabel: 'Choose country or region', smsCodeLabel: 'SMS verification code', agreementPrefix: 'I agree to the ', agreementAnd: ' and ', continueToSignInLabel: 'Continue to sign in', phoneInvalid: 'Enter a valid phone number.', termsRequired: 'Please accept the Terms of Service and Privacy Policy.',
    signIn: 'Sign in to HiveCloud',
    registerPrompt: 'New to HiveCloud?',
    register: 'Create account',
    identityHint: 'Your credentials are protected by HiveCloud Identity and are never stored in the browser.',
    authenticationProgress: 'Authentication progress', accountVerification: 'Account verification', deviceAuthorization: 'Device authorization', complete: 'Complete', identityServiceNotice: 'Credentials are handled by the identity service', identityServiceNoticeDesc: 'Continue to securely enter your account, password, or multi-factor code in HiveCloud Identity.', continueToIdentity: 'Continue to sign in', smsLoginTitle: 'Sign in with your phone', smsLoginDescription: 'Request a one-time code to sign in or create your HiveCloud account.', phoneNumber: 'Phone number', phoneNumberPlaceholder: 'Enter your phone number', smsCode: 'SMS code', smsCodePlaceholder: 'Enter the 6-digit code', smsTerms: 'I agree to the Terms of Service and Privacy Policy', sendSmsCode: 'Send code', verifySmsCode: 'Verify and sign in', passwordLogin: 'Use password sign-in', smsInputInvalid: 'Enter a valid phone number and accept the terms.', smsSendFailed: 'Unable to send a code. Please try again.', smsRateLimited: 'Too many SMS requests. Please try again later.', smsCodeInvalid: 'Enter the 6-digit SMS code.', smsVerifyFailed: 'The code is invalid or expired. Request a new one.', smsLoginCompleteFailed: 'The code was accepted, but the identity service could not complete sign-in. Please try again later.', smsExpiryHint: 'The code expires in {seconds} seconds.', smsResendHint: 'Request another code in {seconds}s', smsResend: 'Request another code', smsCancel: 'Cancel verification', secureConnection: 'Secure connection', artNoteTitle: 'Stay focused without breaking your flow.', artNoteDescription: 'Account identity and device access stay separate, visible, and under your control.',
    approveSignInTitle: 'Approve HiveCloud sign-in', approveSignInDescription: 'Your identity is verified. Confirm this device authorization and sign-in lifetime.', shortCredentialTitle: 'Short access credentials rotate automatically', shortCredentialDescription: 'Ten minutes is only the access-token lifetime; your choice below controls the real sign-in authorization.', application: 'Application', requestingDevice: 'Requesting device', currentBrowserProfile: 'Current browser profile', authorizationPolicy: 'Authorization policy', trustedPolicy: 'Trusted · up to 90 days', temporaryPolicy: 'Temporary · up to 24 hours', trustThisDevice: 'Trust this device', trustedDeviceHint: 'Use only on a private device.', temporaryDeviceHint: 'Keep shared devices temporary.', cancelRequest: 'Cancel request', approveSignIn: 'Approve sign-in', pendingApproval: 'Pending approval', currentAccount: 'Signed-in account', currentEnvironment: 'Current environment', justNow: 'Just now', temporaryDevice: 'Temporary device', trustedDevice: 'Trusted device', temporaryPolicyDescription: 'Up to 24 hours, suitable for shared computers or temporary environments.', trustedPolicyDescription: 'Up to 90 days, only for a device you own and control.', recommendedWhenUnsure: 'Recommended when you cannot confirm this is a private device', beforeApproval: 'Before you approve', approvalCheckApp: 'The request comes from HiveCloud Web.', approvalCheckDevice: 'This browser and device environment are expected.', approvalCheckTrusted: 'Choose trusted access only on a private device.', approvalPrivacyNotice: 'This page never shows nonces, public keys, signatures, authorization codes, or other technical credentials.',
    callback: 'Completing secure sign-in',
    callbackDesc: 'Verifying your session and device identity.',
    browserUnsupported: 'This browser cannot create a secure device identity',
    browserUnsupportedDesc: 'Use Chrome/Edge 137+, Firefox 129+, or Safari 17+.',
    browserRequirement: 'WebCrypto Ed25519 and IndexedDB are required.',
    overview: 'Overview', runtimes: 'Runtimes', personalWork: 'Personal work', personalWorkDescription: 'Manage personal work items by Runtime and securely open a Web workspace.', personalWorkSubtitle: 'Only title, status, and Runtime binding are stored; never code, credentials, or workspace content.', createPersonalWork: 'New work item', workTitle: 'Title', workTitlePlaceholder: 'For example: Prepare this week’s release notes', workRuntime: 'Bound Runtime', workStatus: 'Status', workUpdatedAt: 'Updated', workVersion: 'Resource version', workSessions: 'Linked Web sessions', noPersonalWork: 'No personal work items yet', personalWorkCreated: 'Work item created', personalWorkSaved: 'Work item saved', personalWorkCreateHint: 'Choose a claimed and available Runtime.', personalWorkOpenHint: 'Opening creates a controlled Cloud-managed Web session.', personalWorkRuntimeUnavailable: 'This Runtime does not currently meet the secure Web launch requirements.', personalWorkSessionNone: 'No linked Web sessions.', personalWorkStatus_TODO: 'To do', personalWorkStatus_IN_PROGRESS: 'In progress', personalWorkStatus_IN_REVIEW: 'In review', personalWorkStatus_COMPLETED: 'Completed', personalWorkStatus_ARCHIVED: 'Archived', devices: 'Devices', sessions: 'Sessions', loginDevices: 'Sign-in devices', loginDevicesTitle: 'Sign-in device management', loginDevicesDescription: 'Manage devices that can sign in to and access this account. Set aliases or remove anything unexpected.', devicesCount: 'devices', loginLocation: 'Login location', lastLoginOrUse: 'Last sign-in / use', deviceNamePlaceholder: 'Enter a device alias', deviceNameRequired: 'Enter a device alias with 1–128 characters.', account: 'Account & security', backToConsole: 'Back to console', securityCenter: 'Account security center', accountProfile: 'Account profile', accountProfileDescription: 'Review account information maintained by the identity service.', devicesEyebrow: 'Device access', sessionsEyebrow: 'Session management', mfaEyebrow: 'Sign-in protection', recoveryEyebrow: 'Identity recovery', lifecycleEyebrow: 'Account lifecycle', legal: 'Privacy & terms', support: 'Support', signOut: 'Sign out', language: 'Language',
    welcome: 'Good morning, {name}', overviewSubtitle: 'Your HiveCloud workspace at a glance.', activeRuntimes: 'Active Runtimes', accountStatus: 'Account status', healthy: 'Healthy', attention: 'Needs attention', viewAll: 'View all', recentRuntimes: 'Recent Runtimes', noData: 'No data yet', loadMore: 'Load more', retry: 'Retry', refresh: 'Refresh', runtimeDetail: 'Runtime details', runtimeId: 'Runtime ID', displayName: 'Cloud display name', version: 'Version', status: 'Status', presence: 'Presence', readiness: 'Readiness', lastSeen: 'Last activity', region: 'Region', claim: 'Claim Runtime', claimCapability: 'Claim capability', expectedVersion: 'Expected version', claimDescription: 'Claiming binds this Runtime to your Cloud Account.', claimPreview: 'Claim preview', confirmClaim: 'Confirm claim', cancel: 'Cancel', claimSuccess: 'Runtime claimed successfully', claimInvalid: 'This claim request expired. Start again.', stepUpRequired: 'Complete multi-factor authentication to continue.', edit: 'Edit', save: 'Save', saved: 'Saved', revoke: 'Revoke', revokeDevice: 'Revoke device', revokeSession: 'Sign out session', revokeAll: 'Sign out all sessions', current: 'Current device', trusted: 'Trusted', untrusted: 'Unverified', revoked: 'Revoked', retired: 'Retired', deviceDescription: 'Manage devices that can access your Cloud Account.', sessionDescription: 'Review recent sign-ins and sign out anything unexpected.', accountDescription: 'Manage profile, sign-in security, and account lifecycle.', security: 'Sign-in security', mfa: 'Multi-factor authentication', enabled: 'Enabled', disabled: 'Not enabled', recovery: 'Lost-device recovery', recoveryDescription: 'Verify your identity and replace a lost device key.', configureMfa: 'Configure MFA', deleteAccount: 'Delete account', cancelDeletion: 'Cancel deletion request', memberSince: 'Member since', policyTitle: 'Privacy & terms', policyUpdated: 'Last updated: August 20, 2026', policyBody: 'HiveCloud processes only the account, device, and audit information required to operate the Runtime control plane. Credentials are never stored in the browser; sessions are protected server-side.', supportTitle: 'Need a hand?', supportBody: 'For sign-in, device recovery, or Runtime claim issues, contact your organization administrator.', contactSupport: 'Contact support', loading: 'Loading…', forbidden: 'You do not have access', unauthorized: 'Your session has expired', notFound: 'Page not found', error: 'Unable to load right now', active: 'Active', online: 'Online', offline: 'Offline', pending: 'Preparing', present: 'Connected', away: 'Away', unknown: 'Unknown', ready: 'Ready', starting: 'Starting', degraded: 'Degraded', recovering: 'Recovering', needs_setup: 'Needs setup', blocked: 'Blocked', confirm: 'Confirm', close: 'Close',
    openInWeb: 'Open in Web',
    openingInWeb: 'Opening securely…',
    webLaunch_popup_blocked: 'Your browser blocked the new window. Allow pop-ups for this site and try again.',
    webLaunch_expired: 'This Web launch expired. Refresh the Runtime status and try again.',
    webLaunch_offline: 'The Runtime is offline. Refresh and try again after it reconnects.',
    webLaunch_fenced: 'The Runtime state changed. Refresh before starting another secure connection.',
    webLaunch_unavailable: 'The Web workspace cannot be opened right now. Refresh and try again.',
    runtimeDeviceInfo: 'Device information',
    runtimeDeviceInfoDescription: 'Reported by the Runtime’s latest heartbeat. Fields that were not reported appear as “—”.',
    runtimeDeviceName: 'Device name',
    operatingSystem: 'Operating system',
    processor: 'Processor',
    memory: 'Memory',
    lastSeenIp: 'Latest source IP',
    availableDisk: 'Available disk',
    protocolVersion: 'Protocol version',
    runtimeCapabilities: 'Runtime capabilities',
    connectionCapabilities: 'Connection capabilities',
    runtimeStartedAt: 'Started at',
    runtimeAlias: 'Cloud alias',
    editRuntimeAlias: 'Edit Cloud alias',
    runtimeAliasDescription: 'The alias follows your account without changing the device’s physical name.',
    runtimeAliasPlaceholder: 'For example: Office workstation',
    runtimeAliasHelp: 'Up to {max} characters. Save an empty value to clear the alias.',
    clearRuntimeAlias: 'Clear alias',
    runtimeAliasSaved: 'Cloud alias updated',
    runtimeAliasTooLong: 'The alias cannot exceed {max} Unicode characters.',
    runtimeAliasForbiddenCharacters: 'The alias cannot contain control or bidirectional text-control characters.',
    runtimeAliasConflict: 'The alias changed elsewhere. The latest version was refreshed and your input was kept. Try saving again.',
    runtimeAliasAlreadyCurrent: 'The latest state was refreshed and the Cloud alias already matches your input.',
    runtimeAliasConflictRefreshFailed: 'The alias conflicted, but the latest state could not be refreshed. Your input was kept; try again later.',
    runtimeAliasSaveFailed: 'The Cloud alias could not be saved. This page was not reported as updated.',
    runtimeAliasUnsupported: 'The current service does not provide an alias version, so editing is unavailable.',
    managedWebSessions: 'Web connection records',
    managedWebSessionsDescription: 'Review Cloud-authorized Web workspace connections. Revocation is complete only after the Runtime acknowledges it.',
    noManagedWebSessions: 'No Cloud-managed Web sessions',
    runtimeSession: 'Runtime session',
    createdAt: 'Created',
    expiresAt: 'Expires',
    revokeWebSessionConfirm: 'Request revocation for this Web session? It remains pending or unverifiable until the Runtime acknowledges it.',
    webRevocationRequested: 'Revocation requested. Waiting for Runtime acknowledgement.',
    webSession_ACTIVE: 'Active',
    webSession_REVOKE_PENDING: 'Revocation pending',
    webSession_REVOKED: 'Revoked',
    webSession_EXPIRED: 'Expired',
    webSession_UNVERIFIABLE: 'Unverifiable',
    securityVersion: 'Security version', profile: 'Profile', dangerZone: 'Danger zone', deletionPendingDescription: 'Deletion is pending. Restore access before the grace period ends.', deletionScheduledDescription: 'Deletion signs out devices and schedules permanent account removal.', identifier: 'Identifier', claimedAt: 'Claimed at', privacyByDesign: 'Privacy by design', serviceTerms: 'Service terms', serviceTermsBody: 'Use of HiveCloud is governed by your organization agreement. Security-relevant actions are audited to protect you and your organization.', contact: 'Contact', runtimeClaim: 'Runtime claim', runtimeClaimDescription: 'Include the Runtime ID when reporting a claim issue.', deviceRecoveryDescription: 'Identity verification is required before replacing a device key.',
  },
} as const

export type MessageKey = keyof typeof messages['zh-CN']
